import React from 'react'
import ThemingContainer from './ThemingContainer'

const Theming = () => <ThemingContainer />
export default Theming
